<template>
  <NavBar></NavBar>
  <div class="claim">
    <div class="surface-card p-2 shadow-2">
      <form @submit.prevent="handleSubmit">
        <div class="grid">
          <div class="col-12 md:col-6">
            <Calendar placeholder="Month" class="w-full" v-model="claimFilterForm.month" view="month" dateFormat="MM"
              :class="[v$.claimFilterForm.month.$error ? 'p-invalid' : '']" />
            <small class="p-error" v-if="v$.claimFilterForm.month.$error">Month is Required</small>
          </div>
          <div class="col-12 md:col-6">
            <Calendar placeholder="Year" class="w-full" v-model="claimFilterForm.year" view="year" dateFormat="yy"
              :class="[v$.claimFilterForm.year.$error ? 'p-invalid' : '']" />
            <small class="p-error" v-if="v$.claimFilterForm.year.$error">Year is Required</small>
          </div>
          <div class="col-12 text-center">
            <Button type="submit" label="Show" :icon="Loading ? 'pi pi-spin pi-spinner' : ' pi pi-search'" outlined>
            </Button>
          </div>
        </div>
      </form>
    </div>
    <Button class="mt-2" label="Add" icon="pi pi-plus" outlined @click="openAddClaimModal"></Button>

    <div class="mt-2" v-if="claimData">
      <ScrollPanel style="width: 100%; height: 285px" :pt="{
        wrapper: {
          style:
            'border-right: 5px solid var(--surface-50); border-bottom: 5px solid var(--surface-50);',
        },
        bary: 'surface-300 opacity-100 border-noround',
      }">
        <div class="claim-table-wrap">
          <table class="w-full table table-border">
            <tr>
              <th>No</th>
              <th>Date</th>
              <th>Description</th>
              <th>Attachment</th>
              <th>Status</th>
              <th>Amount</th>
              <th>Action</th>
            </tr>
            <tr v-for="(item, index) in claimData" :key="item.ClaimId">
              <td>{{ index + 1 }}</td>
              <td>{{ $filters.formateDate(item.ClaimDate) }}</td>
              <td>{{ item.Description }}</td>
              <td v-if="item.Attachment">
                <a target="_blank" :href="item.Attachment">View</a>
              </td>
              <td v-else>No Attachment</td>
              <td>
                <span class="status-badge" :class="statusClass(item.Status)">
                  {{ statusLabel(item.Status) }}
                </span>
              </td>
              <td>$ {{ item.Amount }}</td>
              <td>
                <div class="flex gap-2">
                  <Button v-if="canResendClaim(item)" label="Resend" icon="pi pi-pencil" severity="success" text
                    aria-label="resend" size="small" @click="handleClaimEdit(item)" />
                  <Button v-if="canDeleteClaim(item)" label="Delete" icon="pi pi-trash" severity="danger" text
                    aria-label="delete" size="small" @click="deleteClaim(item)" />
                </div>
              </td>
            </tr>
          </table>
        </div>
      </ScrollPanel>
    </div>

    <Dialog v-model:visible="showPopup" modal :header="claimForm.title" :style="{ width: '50vw' }"
      :breakpoints="{ '1199px': '75vw', '575px': '90vw' }">
      <div class="leaveForm">
        <form @submit.prevent="addOrUpdateClaim">
          <div class="grid">
            <div class="col-12 md:col-4 flex align-items-center">
              <label for="date">Claim Date</label>
            </div>
            <div class="col-12 md:col-8">
              <Calendar id="date" v-model="claimForm.date" showIcon class="w-full"
                :class="[v$.claimForm.date.$error ? 'p-invalid' : '']" />
              <small class="p-error" v-if="v$.claimForm.date.$error">Date is Required</small>
            </div>
          </div>
          <div class="grid">
            <div class="col-12 md:col-4 flex align-items-center">
              <label for="amount">Amount</label>
            </div>
            <div class="col-12 md:col-8">
              <InputNumber id="amount" mode="currency" currency="SGD" inputId="integeronly" v-model="claimForm.amount"
                class="w-full" :class="[v$.claimForm.amount.$error ? 'p-invalid' : '']" />
              <small class="p-error" v-if="v$.claimForm.amount.$error">Amount is Required</small>
            </div>
          </div>
          <div class="grid">
            <div class="col-12 md:col-4 flex align-items-center">
              <label for="description">Description</label>
            </div>
            <div class="col-12 md:col-8">
              <Textarea id="description" v-model="claimForm.description" rows="5" class="w-full" />
            </div>
          </div>
          <div class="grid">
            <div class="col-12 md:col-4 flex align-items-center">
              <label for="description">Upload Receipt</label>
            </div>
            <div class="col-12 md:col-8">
              <InputText id="fileUpload" type="file" class="w-full" :required="!claimForm.selectedClaimId" />
              <small class="resubmission-note block mt-2">
                For resubmissions, the same attachment from the original claim will be used. Therefore, you can skip
                the upload field unless you need to replace it with a new attachment.
              </small>
            </div>
          </div>
          <div class="grid">
            <div class="col-12 md:col-4"></div>
            <div class="col-12 md:col-8">
              <Button type="submit" label="Save" :icon="popLoading ? 'pi pi-spin pi-spinner' : ' pi pi-check'"
                size="large" outlined severity="success" />
            </div>
          </div>
        </form>
      </div>
    </Dialog>
  </div>
  <Footer></Footer>
</template>

<script>
import NavBar from "@/components/NavBar.vue";
import Footer from "@/components/Footer.vue";

import { useVuelidate } from "@vuelidate/core";
import { required } from "@vuelidate/validators";
import axios from "axios";
import moment from "moment";

export default {
  name: "ClaimView",
  setup: () => ({ v$: useVuelidate() }),
  components: {
    NavBar,
    Footer,
  },
  data()
  {
    return {
      isBusy: false,
      claimFilterForm: {
        month: new Date(),
        year: new Date(),
      },
      claimForm: {
        selectedClaimId: null,
        title: "Add Claim",
        date: new Date(),
        amount: null,
        description: null,
      },
      Loading: false,
      popLoading: false,
      showPopup: false,
      claimData: null,
      formHeader: {
        "Content-Type": "multipart/form-data",
      },
      type: [
        { name: "Leave", code: "leave" },
        { name: "MC", code: "mc" },
      ],
    };
  },
  validations()
  {
    return {
      claimFilterForm: {
        month: { required },
        year: { required },
      },
      claimForm: {
        date: { required },
        amount: { required },
      },
    };
  },
  methods: {
    // Reset claim form values to defaults.
    resetClaimForm()
    {
      this.claimForm = {
        selectedClaimId: null,
        title: "Add Claim",
        date: new Date(),
        amount: null,
        description: null,
      };
    },
    // Open the claim modal in add mode.
    openAddClaimModal()
    {
      this.resetClaimForm();
      this.showPopup = true;
      this.resetFileInput();
    },
    // Populate and open the claim modal in edit mode.
    handleClaimEdit(item)
    {
      this.claimForm = {
        selectedClaimId: item.ClaimId,
        title: "Edit Claim",
        date: new Date(item.ClaimDate),
        amount: item.Amount,
        description: item.Description,
      };
      this.showPopup = true;
      this.resetFileInput();
    },
    // Clear the file input so stale file selections are not reused.
    resetFileInput()
    {
      const imagefile = document.querySelector("#fileUpload");
      if (imagefile)
      {
        imagefile.value = "";
      }
    },
    // Normalize status for consistent status checks.
    normalizeStatus(status)
    {
      if (!status)
      {
        return "";
      }
      return String(status).trim().toLowerCase();
    },
    // Human-friendly fallback label for status display.
    statusLabel(status)
    {
      if (!status)
      {
        return "Pending";
      }
      return String(status).trim();
    },
    // Map status to badge color class.
    statusClass(status)
    {
      const normalized = this.normalizeStatus(status);
      if (normalized.includes("approve"))
      {
        return "status-approved";
      }
      if (normalized.includes("reject"))
      {
        return "status-rejected";
      }
      if (normalized.includes("delete"))
      {
        return "status-deleted";
      }
      return "status-pending";
    },
    // Rejected or deleted claims can be resent.
    canResendClaim(item)
    {
      const status = this.normalizeStatus(item.Status);
      return status.includes("reject") || status.includes("delete");
    },
    // Rejected or deleted claims can be removed by employee.
    canDeleteClaim(item)
    {
      const status = this.normalizeStatus(item.Status);
      return status.includes("reject") || status.includes("delete");
    },
    // Delete selected claim then reload list.
    async deleteClaim(item)
    {
      if (this.isBusy) return;
      if (!window.confirm("Are you sure you want to delete this claim?"))
      {
        return;
      }

      try
      {
        this.isBusy = true;
        const response = await axios.delete("claims/delete", {
          params: {
            claimId: item.ClaimId,
          },
        });

        if (response.status == 200)
        {
          if (response.data.success)
          {
            this.$toast.add({
              severity: "success",
              detail: response.data.message,
              group: "br",
              life: 5000,
            });
            this.handleSubmit();
          } else
          {
            this.$toast.add({
              severity: "error",
              detail: response.data.message,
              group: "br",
              life: 5000,
            });
          }
        }
      } catch (error)
      {
        this.$toast.add({
          severity: "error",
          detail: "Failed to delete claim.",
          group: "br",
          life: 5000,
        });
      }
      finally
      {
        this.isBusy = false;
      }
    },
    // Load claims by selected month and year.
    async handleSubmit()
    {
      this.Loading = true;
      const result = await this.v$.claimFilterForm.$validate();
      if (result)
      {
        let month = new Date(this.claimFilterForm.month).getMonth() + 1;
        let year = new Date(this.claimFilterForm.year).getFullYear();
        try
        {
          const response = await axios.get(
            "claims?request.year=" + year + "&request.month=" + month
          );
          console.log(response);
          if (response.status == 200)
          {
            this.Loading = false;
            if (response.data.success)
            {
              this.claimData = response.data.result;
            } else
            {
              this.$toast.add({
                severity: "error",
                detail: response.data.message,
                group: "br",
                life: 5000,
              });
            }
          } else
          {
            this.Loading = false;
          }
        } catch (error)
        {
          this.Loading = false;
        }
      } else
      {
        this.Loading = false;
      }
    },
    // Create a new claim or update an existing claim.
    async addOrUpdateClaim()
    {
      if (this.isBusy) return;
      this.popLoading = true;
      const result = await this.v$.claimForm.$validate();
      var formData = new FormData();
      var imagefile = document.querySelector("#fileUpload");
      if (imagefile && imagefile.files && imagefile.files.length > 0)
      {
        formData.append("image", imagefile.files[0]);
      }
      if (result)
      {
        const postData = {
          ClaimDate: moment(this.claimForm.date).format("MM/DD/YYYY"),
          Description: this.claimForm.description,
          Amount: this.claimForm.amount,
        };
        if (this.claimForm.selectedClaimId)
        {
          postData.ClaimId = this.claimForm.selectedClaimId;
        }

        formData.append(
          "postData",
          JSON.stringify(postData)
        );

        try
        {
          this.isBusy = true;
          let response = null;
          if (this.claimForm.selectedClaimId)
          {
            response = await axios.put(
              "claims/edit",
              formData,
              this.formHeader
            );
          } else
          {
            response = await axios.post(
              "claims",
              formData,
              this.formHeader
            );
          }
          if (response.status == 200)
          {
            this.popLoading = false;
            if (response.data.success)
            {
              this.$toast.add({
                severity: "success",
                detail: response.data.message,
                group: "br",
                life: 5000,
              });
              this.showPopup = false;
              this.resetClaimForm();
              this.resetFileInput();
              this.handleSubmit();
            } else
            {
              this.$toast.add({
                severity: "error",
                detail: response.data.message,
                group: "br",
                life: 5000,
              });
            }
          } else
          {
            this.popLoading = false;
          }
        } catch (error)
        {
          this.popLoading = false;
        }
        finally
        {
          this.isBusy = false;
        }
      } else
      {
        this.popLoading = false;
      }
    },
  },
};
</script>

<style scoped>
.claim-table-wrap {
  overflow-x: auto;
}

.resubmission-note {
  color: #6b7280;
  font-size: 0.85rem;
  line-height: 1.35;
}

.status-badge {
  display: inline-flex;
  align-items: center;
  justify-content: center;
  padding: 0.2rem 0.55rem;
  border-radius: 999px;
  font-size: 0.75rem;
  font-weight: 600;
  letter-spacing: 0.01em;
  white-space: nowrap;
}

.status-approved {
  background: #e8f8ee;
  color: #166534;
}

.status-rejected {
  background: #fdecec;
  color: #991b1b;
}

.status-pending {
  background: #fff7e6;
  color: #92400e;
}

.status-deleted {
  background: #f3f4f6;
  color: #374151;
}

@media (max-width: 575px) {
  .claim {
    padding: 0 0.5rem;
  }

  .claim-table-wrap table {
    min-width: 760px;
  }
}
</style>
